import * as Types from '../../../../../../__generated__/schema';

import { DestinationDetails } from '../../../../../graphql/fragments/DestinationDetails.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListDestinationsAndDefaultsVariables = Types.Exact<{ [key: string]: never }>;

export type ListDestinationsAndDefaults = {
  destinations?: Types.Maybe<Array<Types.Maybe<DestinationDetails>>>;
};

export const ListDestinationsAndDefaultsDocument = gql`
  query ListDestinationsAndDefaults {
    destinations {
      ...DestinationDetails
    }
  }
  ${DestinationDetails}
`;

/**
 * __useListDestinationsAndDefaults__
 *
 * To run a query within a React component, call `useListDestinationsAndDefaults` and pass it any options that fit your needs.
 * When your component renders, `useListDestinationsAndDefaults` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDestinationsAndDefaults({
 *   variables: {
 *   },
 * });
 */
export function useListDestinationsAndDefaults(
  baseOptions?: Apollo.QueryHookOptions<
    ListDestinationsAndDefaults,
    ListDestinationsAndDefaultsVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDestinationsAndDefaults, ListDestinationsAndDefaultsVariables>(
    ListDestinationsAndDefaultsDocument,
    options,
  );
}
export function useListDestinationsAndDefaultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListDestinationsAndDefaults,
    ListDestinationsAndDefaultsVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListDestinationsAndDefaults, ListDestinationsAndDefaultsVariables>(
    ListDestinationsAndDefaultsDocument,
    options,
  );
}
export function useListDestinationsAndDefaultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListDestinationsAndDefaults,
    ListDestinationsAndDefaultsVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListDestinationsAndDefaults, ListDestinationsAndDefaultsVariables>(
    ListDestinationsAndDefaultsDocument,
    options,
  );
}
export type ListDestinationsAndDefaultsHookResult = ReturnType<
  typeof useListDestinationsAndDefaults
>;
export type ListDestinationsAndDefaultsLazyQueryHookResult = ReturnType<
  typeof useListDestinationsAndDefaultsLazyQuery
>;
export type ListDestinationsAndDefaultsSuspenseQueryHookResult = ReturnType<
  typeof useListDestinationsAndDefaultsSuspenseQuery
>;
export type ListDestinationsAndDefaultsQueryResult = Apollo.QueryResult<
  ListDestinationsAndDefaults,
  ListDestinationsAndDefaultsVariables
>;
export function mockListDestinationsAndDefaults({
  data,
  variables,
  errors,
}: {
  data: ListDestinationsAndDefaults;
  variables?: ListDestinationsAndDefaultsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: ListDestinationsAndDefaultsDocument, variables },
    result: { data, errors },
  };
}
